import { render, staticRenderFns } from "./VChartBody.vue?vue&type=template&id=1f738bbe&scoped=true&"
import script from "./VChartBody.vue?vue&type=script&lang=ts&"
export * from "./VChartBody.vue?vue&type=script&lang=ts&"
import style0 from "./VChartBody.vue?vue&type=style&index=0&id=1f738bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f738bbe",
  null
  
)

export default component.exports